import { getUserName } from 'models';
import { useTranslation } from 'react-i18next';
import { Button, Col, Delete2LineIcon, Empty, Row, Text } from 'ui';
import { IconDirectMessageButton } from 'features/chat';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
import { AvatarLink, type QuickViewCardUser, UserLink, UserPopover } from 'features/users/components';

export type User = QuickViewCardUser;

type P = {
  onDeleteUser?: (user: User) => void;
  users?: User[];
};

const UserList = ({ onDeleteUser, users }: P) => {
  const { t } = useTranslation();

  return (
    <div className="community-user-list">
      {!users || users.length === 0 ? (
        <Empty />
      ) : (
        users.map((user) => (
          <Row className="community-user-list__row" key={user.id}>
            <Col className="community-user-list__avatar">
              <UserPopover user={user}>
                <AvatarLink
                  avatar={{
                    alt: t('userAvatarProfilePhoto', { name: getUserName(user) }),
                    photo: user.profilePhoto,
                  }}
                  userId={user.id}
                />
              </UserPopover>
            </Col>
            <Col className="community-user-list__label community-user-list__right-stretch">
              <Row align="middle" className="community-user-list__label__content">
                <Col className="community-user-list__right-stretch">
                  <UserPopover user={user}>
                    <UserLink userId={user.id}>
                      {/** TODO: underline doesnt work with ellipsis */}
                      <Text ellipsis strong type="secondary">
                        {getUserName(user)}
                      </Text>
                    </UserLink>
                  </UserPopover>
                </Col>
                <Col>
                  <Row align="middle">
                    <IconDirectMessageButton legacyUserId={user.id} />
                    {onDeleteUser ? (
                      <Button
                        danger
                        icon={<Delete2LineIcon />}
                        onClick={() => {
                          onDeleteUser(user);
                        }}
                        type="link-primary"
                      />
                    ) : null}
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        ))
      )}
    </div>
  );
};

export default UserList;
